export const defaultAttackCombos = 
[
  {
    "code": "V5",
    "approach": "R",
    "ballType": "H",
    "name": "Hut",
    "startZone": "4",
    "coords": "4912",
    "targetHitter": "F",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 12,
      "y": 49
    }
  },
  {
    "code": "V6",
    "approach": "L",
    "ballType": "H",
    "name": "Red",
    "startZone": "2",
    "coords": "4988",
    "targetHitter": "B",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 88,
      "y": 49
    }
  },
  {
    "code": "V8",
    "approach": "C",
    "ballType": "H",
    "name": "High D",
    "startZone": "9",
    "coords": "4186",
    "targetHitter": "B",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 86,
      "y": 41
    }
  },
  {
    "code": "VP",
    "approach": "C",
    "ballType": "H",
    "name": "Pipe",
    "startZone": "8",
    "coords": "4150",
    "targetHitter": "P",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 50,
      "y": 41
    }
  },
  {
    "code": "V0",
    "approach": "C",
    "ballType": "H",
    "name": "High A",
    "startZone": "7",
    "coords": "4114",
    "targetHitter": "F",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 14,
      "y": 41
    }
  },
  {
    "code": "VB",
    "approach": "C",
    "ballType": "H",
    "name": "High C",
    "startZone": "8",
    "coords": "4163",
    "targetHitter": "P",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 63,
      "y": 41
    }
  },
  {
    "code": "VR",
    "approach": "C",
    "ballType": "H",
    "name": "High B",
    "startZone": "8",
    "coords": "4137",
    "targetHitter": "P",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 37,
      "y": 41
    }
  },
//   {
//     "code": "XF",
//     "approach": "L",
//     "ballType": "Q",
//     "name": "Quick lower set behind",
//     "startZone": "2",
//     "coords": "4976",
//     "targetHitter": "C",
//     "isBackcourt": null,
//     "hittingPoint": {
//       "x": 76,
//       "y": 49
//     }
//   },
  {
    "code": "XO",
    "approach": "L",
    "ballType": "Q",
    "name": "5 by the opposite",
    "startZone": "2",
    "coords": "4976",
    "targetHitter": "B",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 76,
      "y": 49
    }
  },
  {
    "code": "XQ",
    "approach": "L",
    "ballType": "Q",
    "name": "5 by O with MB back",
    "startZone": "2",
    "coords": "4976",
    "targetHitter": "B",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 76,
      "y": 49
    }
  },
  {
    "code": "XS",
    "approach": "L",
    "ballType": "N",
    "name": "Slide by the opposite",
    "startZone": "2",
    "coords": "4976",
    "targetHitter": "B",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 76,
      "y": 49
    }
  },
  {
    "code": "X9",
    "approach": "R",
    "ballType": "M",
    "name": "OH hits a 10",
    "startZone": "4",
    "coords": "4924",
    "targetHitter": "F",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 24,
      "y": 49
    }
  },
  {
    "code": "XT",
    "approach": "R",
    "ballType": "M",
    "name": "OH hits in middle",
    "startZone": "3",
    "coords": "4950",
    "targetHitter": "F",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 50,
      "y": 49
    }
  },
  {
    "code": "X3",
    "approach": "L",
    "ballType": "M",
    "name": "O hits in middle",
    "startZone": "3",
    "coords": "4950",
    "targetHitter": "B",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 50,
      "y": 49
    }
  },
  {
    "code": "X4",
    "approach": "L",
    "ballType": "M",
    "name": "O hits a 2nd step 4",
    "startZone": "2",
    "coords": "4976",
    "targetHitter": "B",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 76,
      "y": 49
    }
  },
  {
    "code": "XP",
    "approach": "C",
    "ballType": "U",
    "name": "Bic",
    "startZone": "8",
    "coords": "4150",
    "targetHitter": "P",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 50,
      "y": 41
    }
  },
  {
    "code": "X0",
    "approach": "C",
    "ballType": "U",
    "name": "A (fast ball area 5)",
    "startZone": "7",
    "coords": "4114",
    "targetHitter": "F",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 14,
      "y": 41
    }
  },
  {
    "code": "XB",
    "approach": "C",
    "ballType": "U",
    "name": "C Quick Ball",
    "startZone": "8",
    "coords": "4163",
    "targetHitter": "P",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 63,
      "y": 41
    }
  },
  {
    "code": "XR",
    "approach": "C",
    "ballType": "U",
    "name": "B Quick Ball",
    "startZone": "8",
    "coords": "4138",
    "targetHitter": "P",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 38,
      "y": 41
    }
  },
  {
    "code": "X5",
    "approach": "R",
    "ballType": "T",
    "name": "Go",
    "startZone": "4",
    "coords": "4912",
    "targetHitter": "F",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 12,
      "y": 49
    }
  },
  {
    "code": "X6",
    "approach": "L",
    "ballType": "T",
    "name": "X",
    "startZone": "2",
    "coords": "4988",
    "targetHitter": "B",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 88,
      "y": 49
    }
  },
  {
    "code": "X8",
    "approach": "C",
    "ballType": "T",
    "name": "D",
    "startZone": "9",
    "coords": "4186",
    "targetHitter": "B",
    "isBackcourt": 1,
    "hittingPoint": {
      "x": 86,
      "y": 41
    }
  },
  {
    "code": "X1",
    "approach": "R",
    "ballType": "Q",
    "name": "Quick in front (4)",
    "startZone": "3",
    "coords": "4956",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 56,
      "y": 49
    }
  },
  {
    "code": "X7",
    "approach": "R",
    "ballType": "Q",
    "name": "2",
    "startZone": "4",
    "coords": "4932",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 32,
      "y": 49
    }
  },
  {
    "code": "X2",
    "approach": "L",
    "ballType": "Q",
    "name": "Quick ball back(5)",
    "startZone": "2",
    "coords": "4868",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 68,
      "y": 48
    }
  },
  {
    "code": "XM",
    "approach": "C",
    "ballType": "Q",
    "name": "Quick in Center",
    "startZone": "3",
    "coords": "4949",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 49,
      "y": 49
    }
  },
  {
    "code": "XG",
    "approach": "R",
    "ballType": "Q",
    "name": "7-1 Gun",
    "startZone": "3",
    "coords": "4946",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 46,
      "y": 49
    }
  },
  {
    "code": "XC",
    "approach": "R",
    "ballType": "Q",
    "name": "4- hitter jumps away",
    "startZone": "3",
    "coords": "4947",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 47,
      "y": 49
    }
  },
  {
    "code": "XD",
    "approach": "R",
    "ballType": "Q",
    "name": "2- hitter jumps away",
    "startZone": "3",
    "coords": "4941",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 41,
      "y": 49
    }
  },
  {
    "code": "XL",
    "approach": "C",
    "ballType": "Q",
    "name": "4-setter in area 2",
    "startZone": "2",
    "coords": "4963",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 63,
      "y": 49
    }
  },
  {
    "code": "CB",
    "approach": "L",
    "ballType": "N",
    "name": "Slide near S",
    "startZone": "2",
    "coords": "4976",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 76,
      "y": 49
    }
  },
  {
    "code": "CF",
    "approach": "L",
    "ballType": "N",
    "name": "Slide moved from S",
    "startZone": "2",
    "coords": "4970",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 70,
      "y": 49
    }
  },
  {
    "code": "CS",
    "approach": "L",
    "ballType": "N",
    "name": "Slide far from S",
    "startZone": "2",
    "coords": "4986",
    "targetHitter": "C",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 86,
      "y": 49
    }
  },
  {
    "code": "PP",
    "approach": "L",
    "ballType": "O",
    "name": "Setter Dump",
    "startZone": "3",
    "coords": "4964",
    "targetHitter": "S",
    "isBackcourt": null,
    "hittingPoint": {
      "x": 64,
      "y": 49
    }
  }
];

export function getHittingPoint(code) {
  const combo = defaultAttackCombos.find((c) => c.code === code);
  return combo ? combo.hittingPoint ? combo.hittingPoint : null : null;
}